import { apiUri } from '@/constants'
import { useAppSettings } from '@/hooks/settings'

import { LiveEventsHandler } from './LiveEventsHandler'

export const AppTooling = () => {
  const appSettings = useAppSettings()

  return (
    <LiveEventsHandler
      authenticateUri={`${apiUri}/live-events`}
      liveEventsUri={appSettings.data?.liveEventsUri}
    />
  )
}
